
import { combineReducers } from 'redux';

import map from './map';

export { getLayer, getLayers, getTempFeature, getToolsMode } from './map';

export default combineReducers({
    map
});
